var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "color-picker-component",
      class: { "color-picker-component-large": _vm.large },
    },
    [
      _c(
        "div",
        {
          ref: "colorSlider",
          staticClass: "color-slider",
          on: {
            mousedown: _vm.onWindowMouseDown,
            touchstart: _vm.onWindowMouseDown,
          },
        },
        [
          _vm._l(_vm.colors, function (color, index) {
            return _c(
              "div",
              {
                staticClass: "color-slider-item",
                attrs: {
                  "data-color": color.colors.primary,
                  "data-color-name": color.id,
                },
              },
              [
                _c("div", {
                  staticClass: "color-slider-item-color",
                  class: _vm.getColorSliderItemClasses(index),
                  style: _vm.getColorSliderItemStyles(color),
                  on: {
                    click: function ($event) {
                      return _vm.onColorClick(color)
                    },
                  },
                }),
                _c("div", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isColorSliderActive(color),
                      expression: "isColorSliderActive(color)",
                    },
                  ],
                  staticClass: "color-slider-item-active",
                  style: _vm.getColorSliderItemStyles(color),
                }),
              ]
            )
          }),
          _vm.patterns && _vm.patterns.length
            ? _c(
                "div",
                {
                  staticClass: "color-slider-item color-slider-item-pattern",
                  attrs: { "data-color-name": "pattern" },
                },
                [
                  _c("div", {
                    staticClass: "color-slider-item-color last",
                    style: _vm.getColorSliderItemStyles(_vm.patterns[0]),
                  }),
                  _c("div", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activePattern,
                        expression: "activePattern",
                      },
                    ],
                    staticClass: "color-slider-item-active",
                    style: _vm.getColorSliderItemStyles(_vm.patterns[0]),
                  }),
                ]
              )
            : _vm._e(),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "color-pallet" },
        [
          _c(
            "div",
            {
              staticClass: "color-pallet-eyedropper",
              class: {
                "color-pallet-eyedropper-selected":
                  _vm.isColorFromEyeDropperSelected(),
              },
              style: _vm.colorPalletEyeDropperStyles,
              on: { click: _vm.onEyeDropperClick },
            },
            [
              _c(
                "IconComponent",
                { style: _vm.colorPalletEyeDropperIconStyles },
                [_vm._v("color_picker")]
              ),
            ],
            1
          ),
          _vm._l(_vm.selectedColorPallet, function (color) {
            return _c(
              "color-pallet-item",
              {
                key: color,
                staticClass: "color-pallet-item",
                class: _vm.getColorPalletItemClasses(color),
                style: _vm.getColorPalletStyles(color),
                attrs: { "data-color": _vm.getColorPalletItemDataColor(color) },
                on: {
                  click: function ($event) {
                    return _vm.onColorPalletClick(color)
                  },
                },
              },
              [
                _c(
                  "IconComponent",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !!_vm.getColorPalletItemIcon(color),
                        expression: "!!getColorPalletItemIcon(color)",
                      },
                    ],
                  },
                  [_vm._v(_vm._s(_vm.getColorPalletItemIcon(color)))]
                ),
              ],
              1
            )
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }